import * as yup from 'yup';

// Employee form validation schema
export const employeeValidationSchema = yup.object({
  employee_id: yup
    .string()
    .trim()
    .required('Employee ID is required')
    .min(2, 'Employee ID must be at least 2 characters'),
  full_name: yup.string().trim().required('Full name is required').min(2, 'Full name must be at least 2 characters'),
  email: yup
    .string()
    .trim()
    .nullable()
    .transform((value, originalValue) => (originalValue?.trim() === '' ? null : value))
    .email('Invalid email format'),
  phone: yup.string().trim().required('Phone is required').min(10, 'Phone number must be at least 10 digits'),
  identity_number: yup.string().nullable().trim().max(255, 'Identity number must be less than 255 characters'),
  shift: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' || originalValue === null ? null : value))
    .typeError('Shift must be a valid value'),
  designation: yup.string().required('Designation is required'),
  department: yup.string().required('Department is required'),
  basic_salary: yup
    .number()
    .min(0, 'Basic salary must be zero or greater')
    .typeError('Basic salary must be a valid number')
    .nullable(),
  salary_currency: yup.string().oneOf(['PKR', 'USD', 'AED', 'EUR', 'GBP'], 'Invalid currency selected').nullable(),
  transport_allowance: yup
    .number()
    .min(0, 'Transport allowance must be zero or greater')
    .typeError('Transport allowance must be a valid number')
    .nullable(),
  other_allowances: yup
    .number()
    .min(0, 'Other allowances must be zero or greater')
    .typeError('Other allowances must be a valid number')
    .nullable(),
  tax_deductions: yup
    .number()
    .min(0, 'Tax deductions must be zero or greater')
    .typeError('Tax deductions must be a valid number')
    .nullable(),
  take_home_salary: yup
    .number()
    .min(0, 'Take home salary must be zero or greater')
    .typeError('Take home salary must be a valid number')
    .nullable(),
  joining_date: yup.date().required('Joining date is required').typeError('Invalid date format'),
  resignation_date: yup
    .date()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .typeError('Invalid date format'),
  bank_name: yup.string().nullable().trim().max(255, 'Bank name must be less than 255 characters'),
  bank_account_number: yup.string().nullable().trim().max(255, 'Bank account number must be less than 255 characters'),
  bank_account_title: yup.string().nullable().trim().max(255, 'Bank account title must be less than 255 characters'),
  remarks: yup.string().nullable().trim().max(500, 'Remarks must be less than 500 characters'),
  is_active: yup.boolean(),
});

// User creation validation schema
export const userCreationValidationSchema = yup.object({
  username: yup
    .string()
    .trim()
    .required('Username is required')
    .min(3, 'Username must be at least 3 characters')
    .matches(/^[a-zA-Z0-9_]+$/, 'Username can only contain letters, numbers, and underscores'),
  first_name: yup.string().trim().required('First name is required').min(2, 'First name must be at least 2 characters'),
  last_name: yup.string().trim().required('Last name is required').min(2, 'Last name must be at least 2 characters'),
  password: yup.string().trim().required('Password is required').min(8, 'Password must be at least 8 characters'),
});
